namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class AllAccountCascadeLookupEditor extends Serenity.ServiceLookupEditorBase<AccountCascadeEditorOptions, Nobox.AccountRow> {
        

        public _lastRequest: JQueryXHR;
        public option: AccountCascadeEditorOptions;
        private _channelKD: string;
        public response: Serenity.ListResponse<Master.CitiesRow>;

        constructor(hidden: JQuery, opt: AccountCascadeEditorOptions) {
            super(hidden, opt);
            this.option = opt;
            this.BindToSiteEditor();
        }

        public destroy(): void {
            this.UnbindFromSiteEditor();
            super.destroy();
        }

        public getItemKey(item: Nobox.AccountRow): number {
            return item.Id;
        }

        public getService(): string {
            return "Nobox/Account";
        }

        public getServiceUrl() {
            return "/Services/Nobox/Account/ListAll"
        }

        public getItemText(item: Nobox.AccountRow): string {
            return item.Name;
        }

        public getTypeDelay(): number {
            return 500;
        }

        protected asyncSearch(query: Serenity.Select2SearchQuery, results: (result: Serenity.Select2SearchResult<Nobox.AccountRow>) => void): Serenity.Select2SearchPromise {
            var opt1 = this.getServiceCallOptions(query, results) as Serenity.ServiceOptions<Serenity.ServiceResponse>;
            if (this._channelKD != null) {
                opt1.request.EqualityFilter = {
                    Code: this._channelKD,
                }
            }
            return Q.serviceCall(opt1);
        }

        public GetIncludeColumns(): string[] {
            return [Nobox.AccountRow.Fields.Id, Nobox.AccountRow.Fields.Name];
        }

        private BindToSiteEditor(): void {
            var editor = Q.findElementWithRelativeId(this.element, "ChannelId").tryGetWidget(Serenity.LookupEditor);
            if (editor != null) {
                var self = this;
                editor.change(() => {
                    var item = editor.selectedItem as Master.ChannelRow;
                    if (!Q.isEmptyOrNull(editor.get_value())) {
                        this.ChannelKD = item.Kd;
                    } else {
                        this.ChannelKD = "ajskfhkafkjsncjknzkcn";
                    }
                });
            }
        }

        private UnbindFromSiteEditor(): void {
            var editor = Q.findElementWithRelativeId(this.element, "ChannelId").tryGetWidget(Serenity.LookupEditor);
            if (editor != null)
                editor.element.unbind("." + this.uniqueName);
        }

        public get ChannelEditor(): string {
            return this.option.ChannelEditor;
        }

        public set ChannelEditor(val) {
            if (this.ChannelEditor != val) {
                this.UnbindFromSiteEditor();
                this.option.ChannelEditor = val;
                this.BindToSiteEditor();
            }
        }

        public get ChannelKD(): string {
            return this._channelKD;
        }

        public set ChannelKD(val) {
            if (this._channelKD != val) {
                this._channelKD = val;
                this.value = null;
            }
        }

    }
    interface AccountCascadeEditorOptions extends Serenity.ServiceLookupEditorOptions {
        ChannelEditor: string;
    }

}